import { Input as CGInput } from '@campgladiator/cgui-core.atoms.input'
import { Label, Paragraph } from '@campgladiator/cgui-core.atoms.typography'

const InputUnit = ({ unit }) => (
  <Paragraph className="form__control-input-unit" size="xsmall">
    {unit}
  </Paragraph>
)

const InputError = ({ error }) => (
  <Paragraph className="form__control-input--error-msg" size="xsmall">
    {error}
  </Paragraph>
)

const Input = ({
  type,
  id,
  unit,
  error,
  allowValidCheck = null,
  value,
  inputRef = null,
  ...rest
}) => {
  return (
    <>
      <CGInput
        id={id}
        name={id}
        type={type}
        ref={inputRef}
        {...rest}
        className={`form__control-input ${
          error ? 'form__control-input--error' : ''
        }`}
        value={value}
      />
      {!error && allowValidCheck && value.toString()?.length ? (
        <span className="form__control-input-valid"></span>
      ) : (
        ''
      )}
      {unit && <InputUnit unit={unit} />}
      {error && <InputError error={error} />}
    </>
  )
}

export const LabelInput = ({
  type,
  id,
  label,
  unit,
  error,
  inputRef = null,
  ...rest
}) => (
  <div className="form__control">
    <Label className="form__control-label" size="small" htmlFor={id}>
      {label}
    </Label>
    <Input id={id} error={error} unit={unit} {...rest} type={type} />
  </div>
)

export const LabelTimeInput = ({
  type,
  id,
  label,
  minUnit,
  secUnit,
  minPlaceholder,
  secPlaceholder,
  inputRef = null,
  onChange,
  minId,
  secId,
  minValue,
  secValue,
  minError,
  secError,
  ...rest
}) => (
  <div className="form__control">
    <Label className="form__control-label" size="small" htmlFor={minId}>
      {label}
    </Label>
    <div className="form__control-group">
      <div className="form__control-item">
        <Input
          id={minId}
          unit={minUnit}
          placeholder={minPlaceholder}
          {...rest}
          type={type}
          onChange={onChange}
          value={minValue}
          error={minError}
          data-testid={minId}
        />
      </div>
      <div className="form__control-item">
        <Input
          id={secId}
          unit={secUnit}
          placeholder={secPlaceholder}
          {...rest}
          type={type}
          onChange={onChange}
          value={secValue}
          error={secError}
          data-testid={secId}
        />
      </div>
    </div>
  </div>
)
